import { Button, Modal, styled } from '@ltvco/refresh-lib/theme';

export const StyledButton = styled(Button)(({ theme }) => ({
  borderColor: theme.palette.primary.main,
  color: theme.palette.text.primary,
  fontWeight: 'normal',
  justifyContent: 'flex-start',
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

export const StyledModal = styled(Modal)(({ theme }) => ({
  '.MuiDialog-paper': {
    width: '600px',
    height: '650px',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '92%',
      position: 'fixed',
      bottom: 0,
      margin: 0,
      borderRadius: '24px 24px 0 0',
    },
  },
}));
